<div class="grid grid-cols-[70%_30%] gap-4 w-full h-full px-6 py-4 bg-gray-50">
	<app-e-signing-recipient-status-details
		class="h-full"
		[recipients]="recipients_()"
		[envelopeStatus]="envelopeStatus_()"
	/>
	<app-e-signing-envelope-details
		[documentNames]="documentNames_()"
		[envelope]="envelope_()"
		[matterId]="matterId_()"
	/>
</div>
